<p-card>
    <div class="grid">
        <div class="col-6 md:col-6 lg:col-6 breadcrumbrightmenu">
            <button pButton style="padding: 0.35rem !important;" type="button" icon="fa fa-plus"
                class="dataplus p-button-sm p-button-raised mr-4" pTooltip="Add Login Page Messages"
                tooltipPosition="bottom" (click)="show('Add','')"></button>
            <!-- <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu> -->
            <button pTooltip="Help" tooltipPosition="left" aria-hidden="true" class="fa fa-question helpicon"
                (click)="helpservice.openhelpmodal(ref, dialogService, 'Help', 1)">
            </button>
        </div>
    </div>


    <div class="mr-0" *ngIf="listarray.length>0">
        <p-table #dt [value]="listarray" [rows]="numberofrowsingrid" [scrollable]="true" [customSort]="true"
            (sortFunction)="customSort($event)" scrollDirection="horizontal" scrollHeight="flex"
            [globalFilterFields]="['rid','messagename','fromdate','todate','activeflag']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" sortField="rid"
            [rowsPerPageOptions]="paginatorArray" dataKey="rid" [rowHover]="true" [showCurrentPageReport]="true"
            [resizableColumns]="true" columnResizeMode="expand" paginatorLocale="fa-IR"
            [paginator]="listarray.length>10" [sortOrder]="-1" sortField="fromdate" responsiveLayout="scroll"
            (onPage)="handlePageChange($event)">

            <!-- search -->
            <ng-template pTemplate="caption">
                <div class="grid">
                    <div class="col-3">&nbsp;</div>
                    <div class="col-6">
                        <span class=" p-input-icon-lft"><i icon="pi pi-search"></i>
                            <input class="form-control" pInputText type="text" id="tablesearch"
                                (input)="dt.filterGlobal($any($event.target).value , 'contains'); searchTerm = $any($event.target).value;"
                                placeholder="Search in Login Page Messages" class="tablesearch"
                                pTooltip="Enter Search Criteria" tooltipPosition="top" />
                        </span>
                    </div>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th>Action </th>
                    <th pResizableColumn pSortableColumn="rid">ID<p-sortIcon field="rid"></p-sortIcon></th>
                    <th pResizableColumn pSortableColumn="messagename">Login Page Message<p-sortIcon
                            field="messagename"></p-sortIcon></th>
                    <th pResizableColumn pSortableColumn="fromdate">From Date<p-sortIcon field="fromdate"></p-sortIcon>
                    </th>
                    <th pResizableColumn pSortableColumn="todate">To Date<p-sortIcon field="todate"></p-sortIcon></th>
                    <th pResizableColumn pSortableColumn="activeflag">Status<p-sortIcon field="activeflag"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-data>
                <tr style="vertical-align: top;">
                    <td style="width: 7px !important;">
                        <div style="display: flex; gap: 0px;">
                            <span class="actionItm" pTooltip="View" tooltipPosition="left"> <i class="fa fa-eye"
                                    (click)="show('View',data)"></i></span>&nbsp;
                            <span class="actionItm" pTooltip="Modify" tooltipPosition="left"> <i class="fa fa-edit"
                                    (click)="show('Modify',data)"></i></span>
                        </div>
                    </td>
                    <td (click)="show('View',data)" style="width: 5% !important;" pTooltip="{{data.rid}}"
                        [innerHTML]="highlight(data.rid,searchTerm)">{{data["rid"] }}</td>
                    <td (click)="show('View',data)" class="wrap-col" style="width: 60% !important;"
                        [innerHTML]="highlight(data.messagename,searchTerm)"></td>
                    <td (click)="show('View',data)" style="width: 10% !important;" pTooltip=" {{data['fromdate'] }}"
                        [innerHTML]="highlight(data.fromdate,searchTerm)"></td>
                    <td (click)="show('View',data)" style="width: 10% !important;" pTooltip=" {{data['todate'] }}"
                        [innerHTML]="highlight(data.todate,searchTerm)"></td>
                    <td (click)="show('View',data)" style="width: 10% !important;" pTooltip=" {{data['activeflag'] }}"
                        [innerHTML]="highlight(data.activeflag,searchTerm)"></td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="card" style="margin-top: -4px;" *ngIf="listarray.length==0">
        <p-card>
            <p style="text-align: center;">There is no Data in the Login Page Messages...</p>
        </p-card>
    </div>
</p-card>